import React from 'react';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import { StyledSnackBar, StyledSnackBarContent } from './SnackBarStyle';

const SnackBar = ({
  open,
  message,
  status
}) => {
  const [isOpen, setIsOpen] = React.useState(open);

  const handleClose = () => {
    setIsOpen(false);
  };

  const handleExited = () => {
    setIsOpen(false);
  };

  const action = /*#__PURE__*/React.createElement(IconButton, {
    "aria-label": "close",
    color: "inherit",
    onClick: handleClose
  }, /*#__PURE__*/React.createElement(CloseIcon, null));
  return /*#__PURE__*/React.createElement(StyledSnackBar, {
    key: message,
    anchorOrigin: {
      vertical: 'top',
      horizontal: 'center'
    },
    open: isOpen,
    autoHideDuration: 8000,
    onClose: handleClose,
    onExited: handleExited
  }, /*#__PURE__*/React.createElement(StyledSnackBarContent, {
    message: message,
    action: action,
    status: status
  }));
};

export default SnackBar;